// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InfoStrip_wrapper__Uhv9e","skeleton-loading":"InfoStrip_skeleton-loading__PJM2R"};